function initSizeListUnderline(sizeListContainer) {
    var sizeContainer = sizeListContainer.querySelector('.size_list__container');
    var underline = sizeListContainer.querySelector('.size_list__underline');
    if (!sizeContainer || !underline) return;

    function moveUnderlineTo(label) {
        var cRect = sizeContainer.getBoundingClientRect();
        var lRect = label.getBoundingClientRect();
        underline.style.left = (lRect.left - cRect.left + sizeContainer.scrollLeft) + 'px';
        underline.style.width = lRect.width + 'px';
        underline.style.opacity = '1';
    }

    function moveToSelected() {
        var checked = sizeContainer.querySelector('input[name="size_variant"]:checked');
        if (checked) {
            var label = sizeContainer.querySelector('label[for="' + checked.id + '"]');
            if (label) moveUnderlineTo(label);
        } else {
            underline.style.opacity = '0';
        }
    }

    sizeContainer.querySelectorAll('.size_list__item label').forEach(function(label) {
        label.addEventListener('mouseenter', function() { moveUnderlineTo(this); });
    });

    sizeContainer.addEventListener('mouseleave', function() { moveToSelected(); });

    sizeContainer.querySelectorAll('input[name="size_variant"]').forEach(function(radio) {
        radio.addEventListener('click', moveToSelected);
    });

    moveToSelected();
    // The panel is still hidden when this runs (measures 0), so let the opener
    // re-position the underline once it is visible.
    sizeListContainer._moveUnderlineToSelected = moveToSelected;
}

// Klaviyo's onsite "backinstock" widget only detects a product/variant from
// the current page URL, so it can't work inside this modal (opened via AJAX
// on top of a collection page). Instead we submit straight to Klaviyo's
// public Back in Stock API: https://developers.klaviyo.com/en/docs/how_to_set_up_custom_back_in_stock
function submitKlaviyoBackInStock(container, form) {
    var submitButton = form.querySelector('.klaviyo-back-in-stock-form__submit');
    if (submitButton && submitButton.classList.contains('loading')) return;

    var emailInput = form.querySelector('input[name="email"]');
    var variantIdInput = container.querySelector('#size_list__variant_id') || container.querySelector('input[name="id"]');
    var message = form.querySelector('.klaviyo-back-in-stock-form__message');
    var email = emailInput ? emailInput.value.trim() : '';
    var variantId = variantIdInput ? variantIdInput.value : '';

    if (!email || !variantId) return;

    if (submitButton) submitButton.classList.add('loading');

    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=SQrQsz', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'revision': '2026-07-15'
        },
        body: JSON.stringify({
            data: {
                type: 'back-in-stock-subscription',
                attributes: {
                    profile: {
                        data: {
                            type: 'profile',
                            attributes: { email: email }
                        }
                    },
                    channels: ['EMAIL']
                },
                relationships: {
                    variant: {
                        data: {
                            type: 'catalog-variant',
                            id: '$shopify:::$default:::' + variantId
                        }
                    }
                }
            }
        })
    })
        .then(function(response) {
            if (!response.ok) throw new Error('klaviyo-back-in-stock-failed');
            if (message) {
                message.textContent = window.theme.strings.notifyMeSuccess;
                message.hidden = false;
                message.classList.remove('is-error');
            }
            form.reset();
        })
        .catch(function() {
            if (message) {
                message.textContent = window.theme.strings.notifyMeError;
                message.hidden = false;
                message.classList.add('is-error');
            }
        })
        .finally(function() {
            if (submitButton) submitButton.classList.remove('loading');
        });
}

function isSizeListCompact() {
    return window.matchMedia('(max-width: 1067px)').matches;
}

function submitSizeListForm(container) {
    var form = container.querySelector('#size_list__add_to_cart_form');
    if (!form) return;

    var addButton = form.querySelector('.size_list__add_to_cart');
    if (addButton && addButton.classList.contains('loading')) return;
    if (addButton) addButton.classList.add('loading');

    var formData = new FormData(form);
    var sections = ['main-cart', 'cart-drawer', 'cart-bubble'];
    formData.append('sections', sections.join(','));
    formData.append('sections_url', window.location.pathname);

    fetch(window.theme.routes.cart_add_url, {
        method: 'POST',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/javascript'
        },
        body: formData
    })
        .then(function(response) { return response.json(); })
        .then(function(response) {
            if (response.status) {
                console.error(response.message || response.description);
                return;
            }

            var sectionTargets = [
                { id: 'Cart', section: 'main-cart', selector: '.thb-cart-form' },
                { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
                { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' }
            ];

            sectionTargets.forEach(function(target) {
                var wrapper = document.getElementById(target.id);
                if (!wrapper || !response.sections || !response.sections[target.section]) return;
                var elementToReplace = wrapper.querySelector(target.selector) || wrapper;
                var parsed = new DOMParser().parseFromString(response.sections[target.section], 'text/html');
                var source = parsed.querySelector(target.selector);
                if (source) elementToReplace.innerHTML = source.innerHTML;
            });

            var cartDrawer = document.getElementById('Cart-Drawer');
            if (cartDrawer && typeof cartDrawer.notesToggle === 'function') cartDrawer.notesToggle();
            if (cartDrawer && typeof cartDrawer.discountToggle === 'function') cartDrawer.discountToggle();
            if (cartDrawer && typeof cartDrawer.updateFreeShipping === 'function') cartDrawer.updateFreeShipping();
            if (cartDrawer && typeof OverlayManager !== 'undefined') {
                OverlayManager.open(cartDrawer, ['open-cart']);
            }

            dispatchCustomEvent('cart:item-added', {
                product: response.hasOwnProperty('items') ? response.items[0] : response
            });

            closeSizeList();
        })
        .catch(function(e) { console.error(e); })
        .finally(function() {
            if (addButton) addButton.classList.remove('loading');
        });
}

function initSizeListForm(container) {
    var inner = container.querySelector('.size_list__quick_buy__inner');
    var radios = container.querySelectorAll('input[name="size_variant"]');
    var variantIdInput = container.querySelector('#size_list__variant_id');
    var selectedSizeInput = container.querySelector('#size_list__selected_size');
    var form = container.querySelector('#size_list__add_to_cart_form');
    var addToCartButton = container.querySelector('.size_list__add_to_cart');

    radios.forEach(function(radio) {
        // 'click' (not 'change'): a radio only fires 'change' when its
        // checked state actually flips, so re-clicking the size that's
        // already pre-selected (selected_or_first_available_variant, often
        // the first size) would silently do nothing — no button text update,
        // and no add-to-cart on the mobile compact layout, which relies on
        // this same handler instead of a separate button tap.
        radio.addEventListener('click', function() {
            if (variantIdInput) variantIdInput.value = this.dataset.valueId;
            if (selectedSizeInput) selectedSizeInput.value = this.value;
            if (inner) inner.dataset.selectedAvailable = this.dataset.available;
            if (addToCartButton && this.dataset.available === 'true') {
                addToCartButton.textContent = window.theme.variantStrings.addToCart;
            }

            if (isSizeListCompact() && this.dataset.available === 'true') {
                submitSizeListForm(container);
            }
        });
    });

    // Talla única: only one size is rendered (usually "U"), so there is nothing
    // to choose. Treat it as already picked — without submitting, unlike a tap
    // on the compact layout — so the button reads "add to cart" right away.
    if (radios.length === 1) {
        var onlyRadio = radios[0];
        onlyRadio.checked = true;
        if (variantIdInput) variantIdInput.value = onlyRadio.dataset.valueId;
        if (selectedSizeInput) selectedSizeInput.value = onlyRadio.value;
        if (inner) inner.dataset.selectedAvailable = onlyRadio.dataset.available;
        if (addToCartButton && onlyRadio.dataset.available === 'true') {
            addToCartButton.textContent = window.theme.variantStrings.addToCart;
        }
    }

    container.querySelectorAll('.size_list__item--unavailable').forEach(function(item) {
        item.addEventListener('click', function(event) {
            event.preventDefault();

            var radio = this.querySelector('input[name="size_variant"]');
            if (radio) {
                radio.checked = true;
                radio.dispatchEvent(new Event('click', { bubbles: true }));
            }
        });
    });

    if (form) {
        form.addEventListener('submit', function(event) {
            event.preventDefault();
            submitSizeListForm(container);
        });
    }

    var klaviyoForm = container.querySelector('.klaviyo-back-in-stock-form');
    if (klaviyoForm) {
        klaviyoForm.addEventListener('submit', function(event) {
            event.preventDefault();
            submitKlaviyoBackInStock(container, klaviyoForm);
        });
    }

    initSizeListUnderline(container);
}

function loadPersonalizacion(container) {
    var slot = container.querySelector('[data-personalizacion-slot]');
    var inner = container.querySelector('.size_list__quick_buy__inner');
    if (!slot || !inner) return;

    fetch(slot.dataset.productUrl)
        .then(function(response) { return response.text(); })
        .then(function(html) {
            var parsed = new DOMParser().parseFromString(html, 'text/html');
            var source = parsed.querySelector('product-personalizacion');
            if (!source || !container.contains(slot)) {
                inner.dataset.personalizacion = 'none';
                return;
            }

            slot.appendChild(document.importNode(source, true));
            slot.hidden = false;
            inner.dataset.personalizacion = 'ready';

            if (!customElements.get('product-personalizacion')) {
                var scriptSource = parsed.querySelector('script[src*="product-personalizacion.js"]');
                if (scriptSource) {
                    var script = document.createElement('script');
                    script.src = scriptSource.src;
                    document.head.appendChild(script);
                }
            }
        })
        .catch(function() {
            inner.dataset.personalizacion = 'none';
        });
}

function closeSizeList() {
    var overlay = document.getElementById('overlay_size_list');
    var sizeList = document.getElementById('size_list__quick_buy');
    if (!overlay || !sizeList) return;
    sizeList.classList.remove('show');
    sizeList.classList.add('hidden');
    overlay.classList.add('hidden');
}

document.addEventListener('click', async function(event) {
    const trigger = event.target.closest('.product-card--size-list-button');
    if (!trigger) return;

    event.preventDefault();

    const response = fetch('/products/' + trigger.dataset.handle + '?sections=product-form-modal-bottom', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    })
    .then(response => response.json())
    const htmlJson = await response.then(data => data['product-form-modal-bottom']);


    let parsedHTML = new DOMParser().parseFromString(htmlJson, 'text/html');
    const insideSection = parsedHTML.querySelector('#shopify-section-product-form-modal-bottom');
    const html = insideSection.innerHTML;

    const container = document.getElementById('size_list__quick_buy');


    container.innerHTML = html;

    initSizeListForm(container);
    loadPersonalizacion(container);

    const overlay = document.getElementById('overlay_size_list');
    const sizeList = document.getElementById('size_list__quick_buy');
    sizeList.classList.add('show');
    sizeList.classList.remove('hidden');
    overlay.classList.remove('hidden');

    requestAnimationFrame(function() {
        if (container._moveUnderlineToSelected) container._moveUnderlineToSelected();
    });
});

document.addEventListener('DOMContentLoaded', function() {
    const overlay = document.getElementById('overlay_size_list');
    const sizeList = document.getElementById('size_list__quick_buy');

    overlay.addEventListener('click', function() {
        closeSizeList();
    });



});
